import { render } from "./SpeedBump.vue?vue&type=template&id=1fb56a0a"
import script from "./SpeedBump.vue?vue&type=script&lang=js"
export * from "./SpeedBump.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__